import { useState, useEffect, useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";
import Header from "./Header";
import NearbyMasajid from "./NearbyMasajid";
import BottomNavBar from "./BottomNavBar";

function NearbyPage() {
  const { language } = useContext(MasajidContext);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <>
      <Header />
      <section className="section">
        {!isOnline && (
          <div style={{ marginTop: 64, textAlign: "center" }}>
            <h1
              style={{ color: "#f63c3c", marginTop: 64 }}
              lang={language === "urdu" && "ur"}
            >
              {language === "urdu"
                ? "آپ کا انٹرنیٹ کام نہیں کر رہا"
                : "Please connect to the internet"}
            </h1>
          </div>
        )}

        {isOnline && <NearbyMasajid />}
      </section>
      <BottomNavBar />
    </>
  );
}

export default NearbyPage;
